/**
 * Created by dmitry on 01.04.2025
 */

const Merge3BaseTutorial = function () {
    cleverapps.abExperiments.whenGroupsUpdated(() => {
        if (cleverapps.config.editorMode) {
            return;
        }

        const locationConfig = cleverapps.meta.getLocationMeta("main").locationConfig;
        locationConfig.locationBundleId = Merge3BaseTutorial.isFableGroup() && bundles.location_main_fable ? "location_main_fable" : "location_main";
    });

    return new TutorialScenario(TutorialScenario.BASIC_TUTORIAL_NAME, {
        manual: true,
        listSteps: Merge3BaseTutorial.listSteps,
        isAvailable: function () {
            return cleverapps.gameLevel.getLevel() < 2
                || Map2d.currentMap && (Map2d.currentMap.fogs.blocks.fog0 || Map2d.currentMap.fogs.blocks.fog1 || Map2d.currentMap.fogs.blocks.fog2);
        },
        onStart: function () {
            cleverapps.focusManager.setEventNodes([]);
        },
        onFinish: function () {
            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
        }
    });
};

Merge3BaseTutorial.listSteps = function () {
    if (Merge3BaseTutorial.isFableMap()) {
        return Merge3BaseTutorial.createSteps(Merge3BaseTutorial.FABLE_STEPS, Merge3BaseTutorial.createFableAdviceStep);
    }

    const createAdviceStep = cleverapps.config.name === "mergecraft" ? Merge3BaseTutorial.createAbTestAdviceStep : MergeTutorialHelper.createAdviceStep;
    return Merge3BaseTutorial.createSteps(Merge3BaseTutorial.STEPS, createAdviceStep);
};

Merge3BaseTutorial.createSteps = function (list, createAdviceStep) {
    const steps = [];

    list.forEach((data) => {
        if (data.wait) {
            steps.push(Merge3BaseTutorial.createWaitStep(data.wait));
        }

        if (data.advice) {
            steps.push(createAdviceStep(data.advice));
        }

        if (data.tapToolbar) {
            steps.push(Merge3BaseTutorial.createTapToolbarStep(data.tapToolbar));
        }

        if (data.unlockFog) {
            steps.push(MergeTutorialHelper.createUnlockFogStep(data.unlockFog));
        }

        if (data.updateFogsState) {
            steps.push(Merge3BaseTutorial.createUpdateFogsStateStep(data.updateFogsState));
        }

        if (data.spawnUnit) {
            steps.push(Merge3BaseTutorial.createSpawnUnitStep(data.spawnUnit));
        }

        if (data.openFogs) {
            steps.push(Merge3BaseTutorial.createOpenFogsStep(data.openFogs));
        }

        if (data.spawnPrizes) {
            steps.push(Merge3BaseTutorial.createSpawnPrizesStep(data.spawnPrizes));
        }

        if (data.changeZoom) {
            steps.push(Merge3BaseTutorial.createChangeZoomStep(data.changeZoom));
        }

        if (data.dialogue) {
            steps.push(Merge3BaseTutorial.createDialogueStep(data.dialogue));
        }

        if (data.fogBlocker) {
            steps.push(Merge3BaseTutorial.createFogBlockerStep(data.fogBlocker));
        }
    });

    return steps;
};

Merge3BaseTutorial.createWaitStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const finish = cleverapps.once(this.finish.bind(this));

            if (data.fog) {
                const fogBlock = Map2d.currentMap.fogs.blocks[data.fog];
                if (!fogBlock || fogBlock.state === FogBlock.CANOPEN) {
                    finish();
                    return;
                }

                fogBlock.on("updateState", (state) => {
                    if (state === FogBlock.CANOPEN) {
                        finish();
                    }
                }, this);
            }

            if (data.event) {
                cleverapps.tutorial.on(data.event, (options) => {
                    if (data.targets && !cleverapps.intersect(data.targets, options.unit, Unit.GetKey).length) {
                        return;
                    }

                    if (data.takePrizes) {
                        options.unit.takePrizes();
                    }

                    const nextStepDelay = data.nextStepDelay * 1000 || 0;
                    if (nextStepDelay) {
                        Map2dLocation.currentLocation.counter.setTimeout(() => {}, nextStepDelay);
                    }

                    finish();
                }, this);
            }

            cleverapps.timeouts.setTimeout(finish, data.duration || 5000);
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createUpdateFogsStateStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            Map2dLocation.currentLocation.map.fogs.calcFogStates();
            cleverapps.timeouts.setTimeout(this.finish.bind(this), (data.nextStepDelay || 0) * 1000);
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createSpawnUnitStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            let cell;

            if (data.region) {
                const region = Map2dLocation.currentLocation.map.regions[data.region];
                cell = region && region.positions && region.positions[0];
            }

            if (!cell || Map2dLocation.currentLocation.map.listAvailableUnits(data).length) {
                this.finish();
                return;
            }

            const unit = new Unit({
                x: cell.x,
                y: cell.y,
                code: data.code,
                stage: data.stage,
                heroTutorial: data.heroTutorial
            });
            unit.setPosition(cell.x, cell.y);
            Map2d.currentMap.add(Map2d.LAYER_UNITS, cell.x, cell.y, unit);
            Map2d.currentMap.onAddUnit(unit.x, unit.y, unit);
            Map2d.currentMap.onUnitAvailable(unit);

            const heroTutorial = unit.findComponent(HeroTutorial);
            if (heroTutorial) {
                heroTutorial.start(() => this.finish());
                return;
            }

            this.finish();
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

// opens silently and replaces in one step: the next step starts a few frames later and would show the original units
Merge3BaseTutorial.createOpenFogsStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            MergeTutorialHelper.showOnlyControls();

            data.ids.forEach((id) => {
                if (Map2d.currentMap.fogs.blocks[id]) {
                    Map2d.currentMap.fogs.blocks[id].unlock(undefined, true);
                }
            });

            this.finish();
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createSpawnPrizesStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const map = Map2dLocation.currentLocation.map;
            const region = map.regions[data.region];
            const parent = region && map.getUnit(region.positions[0].x, region.positions[0].y);
            const missing = data.minUnits - map.listAvailableUnits(data.prizes).length;

            if (parent && missing > 0) {
                Map2dLocation.currentLocation.spawn(cleverapps.arrayFill(missing, data.prizes), parent);
            }

            this.finish();
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createChangeZoomStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const zoom = connector.info.isMobile ? data.mobileZoom : data.zoom;
            const map = cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent).map;

            let zoomFocus;
            if (data.fogFocus) {
                const fogBlock = Map2d.currentMap.fogs.blocks[data.fogFocus];
                const fogHead = fogBlock && fogBlock.head;
                if (fogHead) {
                    zoomFocus = fogHead.onGetView() || Map2d.currentMap.getMapView().getCell(fogHead.x, fogHead.y);
                }
            }

            if (data.unitFocus) {
                const unit = Map2d.currentMap.listAvailableUnits(data.unitFocus)[0];
                zoomFocus = unit && unit.onGetView();
            }

            const normalizedZoom = map.zoomHandler.normalizeZoom(zoom);
            map.runAction(new cc.Sequence(
                new cc.ZoomAction(1, {
                    zoom: normalizedZoom,
                    zoomFocus
                }),
                new cc.CallFunc(this.finish.bind(this))
            ));
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createAbTestAdviceStep = function (adviceData) {
    const isStepAdvice = (index) => {
        const step = Merge3BaseTutorial.STEPS[index];
        return step && step.advice && step.advice === adviceData;
    };

    const modifiedData = {
        ...adviceData,
        abTest: true,
        abTestFingerDelay: 0.1
    };

    if (modifiedData.type === Map2d.MERGE) {
        modifiedData.noArrow = true;
    }

    if (isStepAdvice(1)) {
        modifiedData.specialMergeEffects = true;
        modifiedData.overlapDuration = 10;
        modifiedData.dialogueTemplate = [{
            templateItems: [
                [{ text: "Merge3BaseTutorial.merge_dwarf_abtest1" }],
                [
                    { text: "Merge3BaseTutorial.merge_dwarf_abtest2" },
                    { getIcon: () => UnitView.getUnitImage({ code: "dwarf", stage: 0 }, { preferStatic: true }) }
                ],
                [{ text: "Merge3BaseTutorial.merge_dwarf_abtest3" }]
            ]
        }];
    }

    if (isStepAdvice(4)) {
        modifiedData.specialMergeEffects = true;
        modifiedData.dialogueTemplate = [{
            templateItems: [
                [{ text: "Merge3BaseTutorial.merge_wheat1_1" }],
                [{
                    textWithIcon: "Merge3BaseTutorial.merge_wheat1_2",
                    getIcons: () => [
                        UnitView.getUnitImage({ code: "wheat", stage: 1 }, { preferStatic: true }),
                        UnitView.getUnitImage({ code: "wheat", stage: 2 }, { preferStatic: true })
                    ],
                    highlight: true
                }]
            ]
        }];
    }

    if (isStepAdvice(8)) {
        modifiedData.controls = [];
        modifiedData.arrowDelay = 0.5;
        modifiedData.arrowType = "sideArrow";
        modifiedData.adviceMoveCustomization = true;
    }

    return MergeTutorialHelper.createAdviceStep(modifiedData);
};

Merge3BaseTutorial.isFableGroup = function () {
    return cleverapps.abExperiments.getGroup(ABExperiments.Tests.fabletutor) === "A";
};

Merge3BaseTutorial.isFableMap = function () {
    return cleverapps.meta.getLocationMeta("main").locationConfig.locationBundleId === "location_main_fable";
};

Merge3BaseTutorial.createFableAdviceStep = function (adviceData) {
    const data = {
        ...adviceData,
        fable: true,
        abTest: true,
        abTestFingerDelay: 0,
        arrowDelay: 0,
        highlight: false,
        highlightMerge: false
    };

    if (data.type === Map2d.MERGE && data.noArrow === undefined) {
        data.noArrow = true;
    }

    return MergeTutorialHelper.createAdviceStep(data);
};

Merge3BaseTutorial.createTapToolbarStep = function (data) {
    return new TutorialStep({
        onCheckConditions: function (options) {
            return options.toolbarItem === data.item || Boolean(options.manualClose);
        },

        onStart: function () {
            const item = cleverapps.toolbar.getItem(data.item);
            const view = item && item.onGetView();
            const unit = Map2d.currentMap.listAvailableUnits(data.targets)[0];
            const customer = unit && unit.findComponent(Customer);

            if (!view || !customer || cleverapps.focusManager.currentWindow()) {
                this.finish();
                return;
            }

            if (data.recipe) {
                customer.order(new CustomerRecipe(data.recipe));
            } else if (!customer.recipe) {
                customer.order();
            }

            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);

            MergeTutorialHelper.showOnlyControls(data.controls);

            Map2d.currentMap.getMapView().spotlight.show([]);

            this.listTargetRects = () => [view.getSceneBoundingBox()];

            this.content = ComponentUtils.findChildByName(view, "content") || view;
            this.content.runAction(new cc.RepeatForever(new cc.Sequence(
                StandartAnimations.pulse(this.content, { scaleRate: 1.15, duration: 0.6 }),
                new cc.DelayTime(0.8)
            )));

            this.dialogue = MergeTutorialHelper.createMinimalDialogue(data);
            this.finger = FingerView.hintTap(this.content, { repeatDelay: 2 });

            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            FingerView.remove(this.finger);

            if (this.content) {
                this.content.stopAllActions();
                this.content.setScale(this.content.baseScale || 1);
            }

            if (this.dialogue) {
                this.dialogue.remove();
            }

            Map2d.currentMap.getMapView().spotlight.hide();

            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createDialogueStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const scene = cleverapps.Scenes.GetRunningScene();
            cleverapps.focusManager.setEventNodes([scene]);

            MergeTutorialHelper.showOnlyControls(data.controls);

            const dialogue = new Dialogue([data], {
                autoClose: true,
                autoScroll: false,
                showUp: true
            });
            dialogue.on("afterClose", this.finish.bind(this));
            new DialogueView(dialogue);

            this.listTargetRects = () => [cc.rect(0, 0, scene.width, scene.height)];
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.createFogBlockerStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const fogBlock = Map2d.currentMap.fogs.blocks[data.id];
            const view = fogBlock && fogBlock.onGetView();

            if (!view || !view.blocker) {
                this.finish();
                return;
            }

            const scene = cleverapps.Scenes.GetRunningScene();
            cleverapps.focusManager.setEventNodes([scene]);
            MergeTutorialHelper.showOnlyControls();
            this.listTargetRects = () => [cc.rect(0, 0, scene.width, scene.height)];

            MergeTutorialHelper.scrollToTarget([fogBlock.head], () => {
                Map2d.currentMap.getMapView().spotlight.show([fogBlock.head]);

                this.advice = cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent).advice;
                this.advice.createArrow({ node: view.blocker, arrowType: "sideArrow" });

                const dialogue = new Dialogue([data], {
                    autoClose: true,
                    autoScroll: false,
                    showUp: true
                });
                dialogue.on("afterClose", this.finish.bind(this));
                new DialogueView(dialogue);
            });
        },

        onFinish: function () {
            if (this.advice) {
                this.advice.removeArrow();
            }

            Map2d.currentMap.getMapView().spotlight.hide();
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

Merge3BaseTutorial.STEPS = [
    {
        unlockFog: {
            id: "fog0",
            silent: true
        }
    },
    {
        spawnUnit: cleverapps.config.name === "hustlemerge" && {
            code: "dwarf",
            stage: 1,
            heroTutorial: true,
            region: "hero_tutorial"
        },

        advice: cleverapps.config.name !== "hustlemerge" && {
            type: Map2d.MERGE,
            targets: { code: "dwarf", stage: 0 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.merge_dwarf",
            noScroll: true
        }
    },
    {
        unlockFog: {
            id: "fog1",
            nextStepDelay: 1
        }
    },
    {
        advice: { // for backward compatibility
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 0 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarAvatarItem", "MenuBarCoinsItem"],
            text: "Merge3BaseTutorial.merge_wheat1"
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 1 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarAvatarItem", "MenuBarCoinsItem"],
            text: "Merge3BaseTutorial.merge_wheat1"
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 2 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarAvatarItem", "MenuBarCoinsItem"],
            text: "Merge3BaseTutorial.merge_wheat2"
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "wheat", stage: 3 },
            prizes: { code: "wheat", stage: 4 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarAvatarItem"],
            text: "Merge3BaseTutorial.spawn_wheat"
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wheat", stage: 4 },
            allMoves: true,
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.TOP,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.collect_wheat"
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "dwarf", stage: 1 },
            prizes: { code: "wands", stage: 0 },
            ingredients: { wheat: 2 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.produce_wands",
            recipeCookingDuration: 0
        }
    },
    {
        changeZoom: {
            zoom: 0.95,
            mobileZoom: 1.2,
            fogFocus: "fog2"
        }
    },
    {
        updateFogsState: {
            id: "fog2",
            nextStepDelay: 0.9
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wands", stage: 0 },
            nextStepDelay: 1,
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.collect_wands"
        }
    },
    {
        unlockFog: {
            id: "fog2",
            nextStepDelay: 0.8
        }
    },
    {
        changeZoom: {
            zoom: 1.5,
            mobileZoom: 1.9
        }
    },
    {
        advice: {
            type: Map2d.START_MINING,
            targets: { code: "woodsource", stage: 1, mined: 0 },
            prizes: { code: "wood", stage: 0 },
            region: "tutor_wood",
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.mine_wood",
            lovesInfoView: true,
            nextStepDelay: 0.5
        }
    },
    {
        wait: {
            event: Map2d.COMPLETE_MINING,
            targets: { code: "woodsource", stage: 1 }
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "woodsource", stage: 1 },
            prizes: { code: "wood", stage: 0 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.collect_wood"
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wood", stage: 0 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.merge_wood"
        }
    }
];

Merge3BaseTutorial.FABLE_STEPS = [
    {
        openFogs: {
            ids: ["fog0", "fog1"]
        }
    },
    {
        changeZoom: {
            zoom: 1.8,
            mobileZoom: 2,
            unitFocus: { code: "wheat", stage: 0 }
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 0 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.merge_wheat1",
            noScroll: true
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 1 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.merge_again"
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 2 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.merge_wheat2",
            litArea: true
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "wheat", stage: 3 },
            prizes: { code: "wheat", stage: 4 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.spawn_wheat"
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wheat", stage: 4 },
            litUnits: { code: "wheat", stage: 3 },
            allMoves: true,
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.TOP,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.fable.collect_wheat"
        }
    },
    {
        tapToolbar: {
            item: ToolbarItem.ORDERS.type,
            targets: { code: "dwarf", stage: 1 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.fable.produce_wands"
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "dwarf", stage: 1 },
            prizes: { code: "wands", stage: 0 },
            ingredients: { wheat: 2 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.take_keys",
            controls: ["toolbar"],
            recipeCookingDuration: 0,
            noScroll: true,
            noArrow: true,
            litArea: true
        }
    },
    {
        changeZoom: {
            zoom: 0.95,
            mobileZoom: 1.2,
            fogFocus: "fog2"
        }
    },
    {
        updateFogsState: {
            id: "fog2",
            nextStepDelay: 0.9
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wands", stage: 0 },
            nextStepDelay: 1,
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.fable.collect_wands"
        }
    },
    {
        wait: {
            fog: "fog2"
        }
    },
    {
        advice: {
            type: Map2d.OPENFOG,
            targets: "fog2",
            arrow: true,
            arrowType: "sideArrow",
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.fable.open_fog",
            nextStepDelay: 0.8
        }
    },
    {
        changeZoom: {
            zoom: 1.5,
            mobileZoom: 1.9
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wheat", stage: 2 },
            minUnits: 5,
            noArrow: false,
            litArea: true,
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.merge_five"
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "wheat", stage: 3 },
            prizes: { code: "wheat", stage: 4 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.harvest_first"
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "wheat", stage: 3 },
            prizes: { code: "wheat", stage: 4 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.harvest_second"
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wheat", stage: 4 },
            litUnits: { code: "wheat", stage: 3 },
            allMoves: true,
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.TOP,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.fable.collect_all"
        }
    },
    {
        tapToolbar: {
            item: ToolbarItem.ORDERS.type,
            targets: { code: "dwarf", stage: 1 },
            recipe: {
                code: "icecream",
                cookingDuration: "10 seconds",
                ingredients: [{ ingredient: "wheat", amount: 4 }],
                order: [{ code: "wands", stage: 0, amount: 5 }]
            },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.fable.produce_wands"
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "dwarf", stage: 1 },
            prizes: { code: "wands", stage: 0 },
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.take_keys",
            controls: ["toolbar"],
            recipeCookingDuration: 0,
            noScroll: true,
            noArrow: true,
            litArea: true
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wands", stage: 0 },
            minUnits: 5,
            noArrow: false,
            litArea: true,
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.merge_keys"
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wands", stage: 1 },
            nextStepDelay: 0.5,
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.fable.collect_key1"
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "wands", stage: 1 },
            nextStepDelay: 1,
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.fable.collect_key2"
        }
    },
    {
        updateFogsState: {
            id: "fog3",
            nextStepDelay: 0.5
        }
    },
    {
        wait: {
            fog: "fog3"
        }
    },
    {
        advice: {
            type: Map2d.OPENFOG,
            targets: "fog3",
            arrow: true,
            arrowType: "sideArrow",
            person: "dwarf",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.fable.open_fog",
            nextStepDelay: 0.8
        }
    },
    {
        updateFogsState: {
            id: "fog4_0",
            nextStepDelay: 0.5
        }
    },
    {
        fogBlocker: {
            id: "fog4_0",
            person: "worker",
            text: "Merge3BaseTutorial.fable.need_plank"
        }
    },
    {
        advice: {
            type: Map2d.START_MINING,
            targets: { code: "woodsource", stage: 1, mined: 0 },
            prizes: { code: "wood", stage: 0 },
            region: "tutor_wood",
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.mine_wood",
            lovesInfoView: true,
            nextStepDelay: 0.5
        }
    },
    {
        wait: {
            event: Map2d.COMPLETE_MINING,
            targets: { code: "woodsource", stage: 1 }
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "woodsource", stage: 1 },
            prizes: { code: "wood", stage: 0 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.collect_wood",
            litArea: true
        }
    },
    {
        advice: {
            type: Map2d.MERGE,
            targets: { code: "wood", stage: 0 },
            minUnits: 5,
            noArrow: false,
            litArea: true,
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.merge_wood"
        }
    },
    {
        updateFogsState: {
            id: "fog4_0",
            nextStepDelay: 0.5
        }
    },
    {
        wait: {
            fog: "fog4_0"
        }
    },
    {
        advice: {
            type: Map2d.OPENFOG,
            targets: "fog4_0",
            arrow: true,
            arrowType: "sideArrow",
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            controls: ["MenuBarWandsItem"],
            text: "Merge3BaseTutorial.fable.open_fog",
            nextStepDelay: 0.8
        }
    },
    {
        advice: {
            type: Map2d.START_MINING,
            targets: { code: "woodsource", stage: 1, mined: 0 },
            prizes: { code: "wood", stage: 0 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.chop_stump",
            lovesInfoView: true,
            nextStepDelay: 0.5
        }
    },
    {
        wait: {
            event: Map2d.COMPLETE_MINING,
            targets: { code: "woodsource", stage: 1 }
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "woodsource", stage: 1 },
            prizes: { code: "wood", stage: 0 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.collect_wood",
            litArea: true
        }
    },
    {
        advice: {
            type: Map2d.START_MINING,
            targets: { code: "woodsource", stage: 1, mined: 1 },
            instantMining: true,
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.chop_again",
            lovesInfoView: true,
            nextStepDelay: 0.5
        }
    },
    {
        wait: {
            event: Map2d.COMPLETE_MINING,
            targets: { code: "woodsource", stage: 1 },
            takePrizes: true,
            nextStepDelay: 2
        }
    },
    {
        advice: {
            type: Map2d.SPAWN,
            targets: { code: "candies", stage: 3 },
            prizes: { code: "candies", stage: 4 },
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
            text: "Merge3BaseTutorial.fable.harvest_fruit"
        }
    },
    {
        advice: {
            type: Map2d.HARVEST,
            targets: { code: "candies", stage: 4 },
            litUnits: { code: "candies", stage: 3 },
            allMoves: true,
            person: "worker",
            gravitate: MinimalDialogue.GRAVITATE.TOP,
            controls: ["toolbar"],
            text: "Merge3BaseTutorial.fable.collect_fruit"
        }
    }
];
